export const dfccClubSchema = {
	schema: {
		title: 'dfcc club schema',
		description: 'DFCC Club Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			town_name_c: {
				type: 'string',
			},
			town_code_c: {
				type: 'string',
			},
			user_type_c: {
				type: 'string',
			},
			user_community_c: {
				type: 'string',
			},
			assigned_cmdi_c: {
				type: 'string',
			},
			area_c: {
				type: 'string',
			},
			members_count: {
				type: 'number',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
		},
		required: [
			'id',
			'sfid',
			'name',
			'town_name_c',
			'town_code_c',
			'user_type_c',
			'user_community_c',
			'assigned_cmdi_c',
			'area_c',
			'members_count',
			'createddate',
		],
	},
};
